export const gamification = {
    showRewards: true
};